import {getWebsite} from '@/apiCloud/home'

const website = {
  state: {
    info: {
      navigateDir: {
        publicCourseLib: 0,
        trainIntroduce: 0,
        practiceCenter: 0,
        examCenter: 0,
        policyAdvice: 0,
        quickService: 0
      },
      homeContent: {
        publicCourseClassify: 0,
        privateCourse: 0,
        offlineCourse: 0,
        policyAdvice: 0,
        processGuid: 0,
        link: 0
      },
      webIcon: "",
      headLogo: "",
      headLinkTel: null,
      footLogo: "",
      invalid: 0,
      entpId: null,
      bannerList: []
    }
  },

  mutations: {
    SET_INFI: (state, info) => {
      state.info = info
    },
  },

  actions: {
    // 获取网站装修信息
    GetWebSite({
      commit
    }) {
      return new Promise((resolve, reject) => {
        let defaultImg = ''
        getWebsite().then(res=>{
          if(res.code==200 && res.data){
            res.data.webIcon = res.data.webIcon || defaultImg;
            res.data.headLogo = res.data.headLogo || defaultImg;
            res.data.footLogo = res.data.footLogo || defaultImg;
            $("#browserIcon").attr("href", res.data.webIcon);
            document.title = res.data.headTitle
            commit('SET_INFI', res.data)
          }
          resolve(res.data)
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
}

export default website



// WEBPACK FOOTER //
// ./src/store/modules/website.js